import React from 'react';
import { Link } from 'react-router-dom';

const Navbar = ({ background = 'transparent' }) => {
  return (
    <nav className="landing-nav" style={{ background }}>
      <Link to="/" style={{ textDecoration: 'none' }}>
        <img src="/logo.png" alt="Kapitalised" style={{ height: '20px' }} />
      </Link>
    </nav>
  );
};

export default Navbar;
